import Vue from 'vue'
let pushtimer = null

Vue.mixin({
	data() {
		return {
			isPc: true,
			flag: true
		}
	},
	computed: {
		En() {
			return this.i18n.locale === 'en' ? 'En' : ''
		},
		windowScrollTop() {
			return this.isPc ? this.$store.state.scrollTop : 0
		},
		windowCenterTop() { // 用来处理PC端缩放之后导致的fixed不生效的问题  如果fixed top为50%  把对应的元素加上:style="{ top: windowCenterTop }"
			return this.isPc ? ( this.windowScrollTop + document.documentElement.clientHeight / 2) * 1920 / document.documentElement.clientWidth + 'px' : '50%'
		},
		turnText() {
			return str => {
				if (str == '展区分布') {
					return this.En ? '展位图' : '展位图'
				} if (str == '资料下载') {
					return this.En ? 'Exhibitor Information' : '展商文件'
				} else {
					return str
				}
			}
		},
		visitorIsClose() { // 观众登记是否显示敬请期待
			return false
		},
	},
	created() {
		this.isPc = document.body.offsetWidth > 768
	},
	methods: {
        copy(content) {
            // 创建输入框元素
            const input = document.createElement('input');//不会保留文本格式
            //如果要保留文本格式，比如保留换行符，或者多行文本，可以使用  textarea 标签，再配和模板字符串 ` `
            //const input = document.createElement('textarea')
            // 将想要复制的值
            input.value = content;
            // 页面底部追加输入框
            document.body.appendChild(input);
            // 选中输入框
            input.select();
            // 执行浏览器复制命令
            document.execCommand('Copy');
            // 弹出复制成功信息
            this.$message.success(this.En ? 'Copy success' : '复制成功');
            // 复制后移除输入框
            input.remove();
        },
		windowOpen(url) {
			window.open(url)
		},
		windowWechat(url) {
			const isWindowsWechat = navigator.userAgent.includes('WindowsWechat')
			if (isWindowsWechat) {
				window.open('https://view.xdocin.com/view?src=' + url)
			} else {
				window.open(url)
			}
		},
		openMatch(path, v) {
			if (v.contentType == 3) {
				window.open(v.linkUrl, "_blank");
			} else if (v.contentType == 4) {
				window.open(v['fileUrl' + this.En], "_blank");
			} else {
				this.$router.push(path)
			}
		},
		goHostHome() {
			this.$jsAPI('track', 'ciif_pageHead_all', { contentName_var: '大会LOGO' })
			this.$jsAPI('track', 'ciif_pageHead_logo')
			this.$store.commit('setExhibitDetail', {})
			this.$router.push('/home')
			this.$store.commit('setHeadIndex', 0)
		},
		sliceStr(str) {
			if (this.$route.query.pageType === 'events') {
				return str
			}
			if (str) {
				return str.slice(0, 11)
			}
			return ''
		},
		pageView(tip, params = {}) {
			clearInterval(pushtimer)
			let timeVal = 1
			let totalTime = 0
			this.$jsAPI('page', tip,
				{
					'page_duration': timeVal,
					...params
				}
			);
			pushtimer = setInterval(() => {
				timeVal = 30
				totalTime += 30 * 1000
				this.$jsAPI('page', tip,
					{
						'page_duration': timeVal,
						...params
					}
				);
				if (totalTime > 2 * 60 * 60 * 1000) {
					clearInterval(pushtimer)
				}
			}, 30 * 1000)
		},
	},
})



// WEBPACK FOOTER //
// ./src/mixin/index.js